import Accordion from '@components/utils/Accordion';
import Markdown from '@components/utils/mdText';
import { TrackEvent } from '@enums';
import {
    GetTextAnswerQuery,
    GetTextAnswersByProductQuery,
} from '@graphql/generated/graphql';
import { useAnalytics } from '@lib/analytics/analyticsContext';
import { StateResultsProvided } from 'react-instantsearch-core';

type TextAnswer = NonNullable<GetTextAnswerQuery['textAnswer']>;

type PropsType = {
    textAnswer: NonNullable<
        UnpackCollection<
            GetTextAnswersByProductQuery,
            'products',
            'Text_answers'
        >
    >;
    index: number;
    searchResults?: StateResultsProvided<TextAnswer>['searchResults'];
};

const TextAnswerCard = ({ textAnswer, index, searchResults }: PropsType) => {
    const { track } = useAnalytics();

    const onOpen = () => {
        track(TrackEvent.QuestionClicked, {
            question_name: textAnswer.Title,
            positions: index,
            ...(searchResults && {
                index: searchResults.index,
                query_id: searchResults.queryID,
            }),
        });
    };

    return (
        <Accordion
            title={textAnswer?.Title}
            index={index}
            onOpen={() => onOpen()}
        >
            <Markdown markdown={textAnswer.Answer} />
        </Accordion>
    );
};

export default TextAnswerCard;
